var CubeTextureSoftware = /** @class */ (function () {
    function CubeTextureSoftware(size) {
        this._textureSelectorDictionary = [[], [], [], [], [], []];
        this._size = size;
    }
    Object.defineProperty(CubeTextureSoftware.prototype, "textureType", {
        get: function () {
            return CubeTextureSoftware.textureType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CubeTextureSoftware.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: false,
        configurable: true
    });
    CubeTextureSoftware.prototype.dispose = function () {
        this._textureSelectorDictionary = null;
    };
    CubeTextureSoftware.prototype.isTexture = function (textureClass) {
        return this.textureType == textureClass.textureType;
    };
    CubeTextureSoftware.prototype.uploadFromArray = function (array, side, miplevel, premultiplied) {
        if (miplevel === void 0) { miplevel = 0; }
        if (premultiplied === void 0) { premultiplied = false; }
        this._textureSelectorDictionary[side][miplevel] = ((array instanceof Array) ? new Uint8ClampedArray(array) : new Uint8ClampedArray(array.buffer));
    };
    CubeTextureSoftware.prototype.getData = function (side, miplevel) {
        if (miplevel === void 0) { miplevel = 0; }
        return this._textureSelectorDictionary[side][miplevel];
    };
    CubeTextureSoftware.prototype.getMipLevelsCount = function () {
        return 1;
    };
    CubeTextureSoftware.prototype.generateMipmaps = function () {
        //TODO
    };
    CubeTextureSoftware.prototype.uploadCompressedTextureFromArray = function (array, offset, async) {
        // TODO
    };
    CubeTextureSoftware.textureType = 'textureCube';
    return CubeTextureSoftware;
}());
export { CubeTextureSoftware };
